var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconKeyboardArrowRightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1274_4833",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1274_4833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.0001L7.25004 6.75008C7.09726 6.5973 7.02087 6.40286 7.02087 6.16675C7.02087 5.93064 7.09726 5.73619 7.25004 5.58341C7.40282 5.43064 7.59726 5.35425 7.83337 5.35425C8.06949 5.35425 8.26393 5.43064 8.41671 5.58341L12.25 9.41675C12.3334 9.50008 12.3924 9.59036 12.4271 9.68758C12.4618 9.7848 12.4792 9.88897 12.4792 10.0001C12.4792 10.1112 12.4618 10.2154 12.4271 10.3126C12.3924 10.4098 12.3334 10.5001 12.25 10.5834L8.41671 14.4167C8.26393 14.5695 8.06949 14.6459 7.83337 14.6459C7.59726 14.6459 7.40282 14.5695 7.25004 14.4167C7.09726 14.264 7.02087 14.0695 7.02087 13.8334C7.02087 13.5973 7.09726 13.4029 7.25004 13.2501L10.5 10.0001Z",
    fill: "#1B4B86"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKeyboardArrowRightBlue);
export default __webpack_public_path__ + "static/media/icon_keyboard_arrow_right_blue.6c9e0c9c754828314bcc79680af81ad0.svg";
export { ForwardRef as ReactComponent };